import { FC } from "react";
import { Complaint } from "./schema";
import { ArrowTopRightOnSquareIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-location";

interface ParentContainerProps {
  complaint: Complaint;
}

const ParentContainer: FC<ParentContainerProps> = ({ complaint }) => {

  const navigate = useNavigate();

  return (
    <section aria-labelledby="parent-title">
      <div className="bg-white px-4 py-6 shadow sm:rounded-lg sm:px-6 flex flex-row items-center justify-between gap-4">
        <div className="flex flex-row items-center gap-4">
          <div className="bg-red-50 text-red-500 flex items-center justify-center p-2 rounded-full w-12 h-12">
            <ExclamationTriangleIcon className="h-6 w-6" />
          </div>
          <div className="flex flex-col gap-1">
            <h2 id="parent-title" className="text-md text-gray-900">
              This ticket is grouped under a similar ticket in <b>{complaint?.district?.name}</b>
            </h2>
            <p className="text-md text-gray-500">
              Complaint #{complaint?.parent?.code}
            </p>
          </div>
        </div>
        <div className="">
          <button
            type="button"
            className="bg-gray-50 text-gray-500 hover:bg-gray-300 hover:text-gray-900 flex items-center justify-center p-2 rounded-full w-12 h-12 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            onClick={() => navigate({to: `/tickets/${complaint?.parent?._id}`})}
          >
            <ArrowTopRightOnSquareIcon className="h-6 w-6" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ParentContainer;
